import { FC } from 'react';

import { getPurpurColor } from '@telialt/common-theme/src/purpurSelectors';
import { Stock } from '@telialt/models/src/EshopModel';

import { ESHOP_TEST_ID } from '../test/test-ids';
import { OutOfStockStatusContainer, StatusColorDot } from './ProductStockStatus.styles';
import { ProductStockText } from './StockText';

type Props = {
    stock: Stock;
};

export const OutOfStockStatus: FC<Props> = ({ stock }) => {
    return (
        <OutOfStockStatusContainer data-test={ESHOP_TEST_ID.PRODUCT_STOCK_STATUS}>
            <StatusColorDot color={getPurpurColor('textStatusErrorMedium')} />
            <ProductStockText stock={stock} />
        </OutOfStockStatusContainer>
    );
};
